// This is browser client only.
import { browser } from '$app/environment';
import { redirect } from '@sveltejs/kit';
import createBrowserClient from './graphQlClients/browserClient';

const sharedServerInstance = {};

export const client = (providedFetch = fetch, serverConfig) => {
    if (browser) {
        // Return instance if exsits
        if (window?.storefrontClient) {
            return window.storefrontClient;
        }
        // Create the client
        let storefrontDomain, storefrontToken, storefrontAPIVersion;
        if (typeof window.config === 'undefined' && typeof Storage !== 'undefined' && window.localStorage.getItem('config')) {
            window.config = JSON.parse(window.localStorage.getItem('config') ?? '');
        }

        if (typeof window.config !== 'undefined') {
            storefrontDomain = window.config.storefrontDomain;
            storefrontToken = window.config.storefrontToken;
            storefrontAPIVersion = window.config.storefrontAPIVersion;
        } else {
            redirect(302, '/');
        }

        window.storefrontClient = createBrowserClient(providedFetch, { storefrontDomain, storefrontToken, storefrontAPIVersion });
        return window.storefrontClient;
    } else {
        // Else SERVER - should only be called from shared loaders as generic/no-caching/public key stuff only...
        console.log('NOTICE: SERVER CALLING NON-CACHE GQL CLIENT - USE PRIVATE SERVER CLIENT FROM API ROUTE OR SERVER LOADER INSTEAD.');

        /// Ensure Config
        if (!serverConfig) {
            throw new Error('Shared client used on server needs shopifyClientConfig!');
        }
        // Redefine config variables for generic client
        const { shopDomain: storefrontDomain, publicToken: storefrontToken, storefrontAPIVersion } = serverConfig;
        const instanceName = storefrontDomain.replaceAll('.', '_');

        // Early return if instance
        if (sharedServerInstance?.[instanceName]) {
            return sharedServerInstance[instanceName];
        }

        sharedServerInstance[instanceName] = createBrowserClient(providedFetch, { storefrontDomain, storefrontToken, storefrontAPIVersion });
        return sharedServerInstance[instanceName];
    }
};
